import axios from './axios';

const MenuService = {
    getMenus: async (restaurant_id) => {
        try {
            const response = await axios.get('/menus', {
                params: { restaurant_ids: restaurant_id  }
            });
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    getMenuItems: async (restaurant_id) => {
        try {
            const response = await axios.get('/menu-items', restaurant_id);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    getMenuItem: async (menuItemId) => {
        try {
            const response = await axios.get(`/menu-items/${menuItemId}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    uploadMenuItemPhoto: async (photo) => {
        try {
            const response = await axios.post(`/uploads/image`, photo);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    getMenu: async (menuItemId) => {
        try {
            const response = await axios.get(`/menus/${menuItemId}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    addMenu: async (menuItem) => {
        try {
            const response = await axios.post(`/menus`, menuItem);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    updateMenu: async (menuItem,id) => {
        try {
            const response = await axios.put(`/menus/${id}`, menuItem);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    addMenuItem: async (menuItem) => {
        try {
            const response = await axios.post(`/menu-items`, menuItem);
            return response.data;
        } catch(e) {
            console.error(e);
        } 
    },
    updateMenuItem: async (menuItem,id) => {
        try {
            const response = await axios.put(`/menu-items/${id}`, menuItem);
            return response.data;
        } catch(e) {
            return e;
        } 
    },
    deleteMenuItem: async(id) => {
        try {
            const response = await axios.delete(`/menu-items/${id}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    addSection: async (menuItem) => {
        try {
            const response = await axios.post(`/menu-groups`, menuItem);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    menugroupById: async (id=13) => {
        try {
            // const response = await axios.post(`menu/2/menu-groups`, menuItem);
            const response = await axios.get(`/menus/${id}/menu-groups`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    deleteMenuGroup: async(id) => {
        try {
            const response = await axios.delete(`/menu-groups/${id}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    updateMenuGroup: async (menuItem,id) => {
        try {
            const response = await axios.put(`/menu-groups/${id}`, menuItem);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    getIngredients: async (id) => {
        try {
            const response = await axios.get(`/ingredients`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    getAllMenuItems: async () => {
        try {
            const response = await axios.get(`/menu-items`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    uploadMenuItemCsv: async (id, formData) => {
        try {
            const response = await axios.post(`/menu-items/csv/${id}`, formData);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
};

export default MenuService;